import Heading from "components/text/heading";
import PrimaryButton from "components/Button/PrimaryButton";
import { Flex, HeadingProps } from "@chakra-ui/layout";
import OutlineButton from "components/Button/OutlineButton";
import colors from "core/resources/theme/colors";
import BadgeButton from "./../../BadgeButton";
import { ButtonProps } from "@chakra-ui/button";

function PageHeader({
  title,
  titleButton,
  titleProps,
  onClick,
  midComponent,
  extraButtonTitle,
  iconButton,
  notificationButtonTitle,
  extraButtonIconPosition = "right",
  iconExtraButton,
  extraButtonOnClick,
  notificationButtonOnClick,
  primaryButtonType = "primary",
  mb = "32px",
  mt = "",
  mlExtraButton = "auto",
  justifyContent,
  permissions,
  badge,
  badgeNotificationButton,
  badgeValueExtraButton,
  badgeValueNotificationButton,
  isLoadingNotificationButton,
  buttonProps,
  extraButtonProps,
  searchComponent,
}: {
  title: any;
  titleButton?: string;
  titleProps?: HeadingProps;
  onClick?: () => any;
  midComponent?: any;
  extraButtonTitle?: string;
  iconButton?: any;
  notificationButtonTitle?: string;
  iconExtraButton?: any;
  extraButtonIconPosition?: "left" | "right";
  extraButtonOnClick?: () => any;
  notificationButtonOnClick?: () => any;
  primaryButtonType?: "primary" | "outline";
  mb?: string;
  mt?: string;
  mlExtraButton?: string;
  justifyContent?: string;
  permissions?: string | string[];
  badge?: boolean;
  badgeNotificationButton?: boolean;
  badgeValueExtraButton?: string | number;
  badgeValueNotificationButton?: string | number;
  isLoadingNotificationButton?: boolean;
  buttonProps?: ButtonProps;
  extraButtonProps?: ButtonProps;
  searchComponent?: React.ReactNode;
}) {
  const Button =
    primaryButtonType === "primary" ? PrimaryButton : OutlineButton;
  return (
    <Flex
      mb={mb}
      justifyContent={justifyContent}
      alignItems="center"
      wrap="wrap"
      gridGap={4}
    >
      <Heading {...titleProps}> {title} </Heading>
      {midComponent ? <Flex>{midComponent}</Flex> : null}

      {searchComponent ? <Flex>{searchComponent}</Flex> : null}
      {titleButton ? (
        <Flex mt={mt}>
          <Button
            permissions={permissions}
            onClick={onClick}
            size="sm"
            fontSize={12}
            fontWeight="normal"
            {...buttonProps}
            // padding={8}
          >
            {titleButton}
            {iconButton}
          </Button>
        </Flex>
      ) : null}
      <Flex ml={mlExtraButton}>
        {extraButtonTitle ? (
          <Flex ml="auto" mt={mt} justifyContent="end">
            <OutlineButton
              position="relative"
              onClick={extraButtonOnClick}
              size="sm"
              fontSize={12}
              fontWeight="normal"
              lineColor={colors.primary}
              m="5px"
              flexDirection={
                extraButtonIconPosition === "right" ? "row" : "row-reverse"
              }
              {...extraButtonProps}
            >
              {extraButtonTitle}
              {iconExtraButton}
            </OutlineButton>

            {badge ? <BadgeButton badgeValue={badgeValueExtraButton} /> : null}
          </Flex>
        ) : null}
        {notificationButtonTitle ? (
          <Flex ml="auto" mt={mt} justifyContent="end">
            <PrimaryButton
              position="relative"
              onClick={notificationButtonOnClick}
              size="sm"
              fontSize={12}
              fontWeight="normal"
              m="5px"
              isLoading={isLoadingNotificationButton}
            >
              {notificationButtonTitle}
            </PrimaryButton>

            {badgeNotificationButton ? (
              <BadgeButton badgeValue={badgeValueNotificationButton} />
            ) : null}
          </Flex>
        ) : null}
      </Flex>
    </Flex>
  );
}

export default PageHeader;
